import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=6af999f4&"
import script from "./CompanySettingsPage.vue?vue&type=script&lang=ts&"
export * from "./CompanySettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports